import { AxiosPromise } from "axios";
import { format } from "date-fns";
import { httpClient } from "src/shared/services/httpClient";
import {
  TMailBoxDetails,
  TMailBoxEmails,
  TMailBoxParams,
  TTotalFilters,
} from "../types";

export const getMailBoxParams = (): AxiosPromise<TMailBoxParams> =>
  httpClient.get("/email/mailbox");
export const getMailBoxEmails = (
  filters: TTotalFilters,
): AxiosPromise<TMailBoxEmails> => {
  const formData = new FormData();
  filters.fromDate &&
    formData.append("fromDate", format(filters.fromDate, "dd/MM/yyyy"));
  filters.toDate &&
    formData.append("toDate", format(filters.toDate, "dd/MM/yyyy"));
  filters.messageTypeId &&
    formData.append("emailTypeId", filters.messageTypeId.toString());
  filters.messageReadTypeId &&
    formData.append("emailReadTypeId", filters.messageReadTypeId.toString());
  formData.append("length", filters.pageSize.toString());
  formData.append("start", (filters.pageIndex * filters.pageSize).toString());
  return httpClient.post("/email/emailsAsJSON", formData);
};

export const getUnreadEmailCount = (): AxiosPromise<{
  myEmailsUnreadCount: number;
}> => {
  return httpClient.get("/email/myEmailsUnreadCountJSON");
};

export const changeEmailsReadFlag = ({
  emails,
  readFlag,
  showNotification,
}: {
  emails: { id: number; emailType: string }[];
  readFlag: boolean;
  showNotification?: boolean;
}) => {
  const formData = new FormData();
  formData.append("forFlagUpdate", JSON.stringify(emails));
  formData.append("readFlag", `${readFlag}`);
  return httpClient.post(`/email/massUpdateReadFlag`, formData);
};

export const getMailDetails = (
  emailType: string,
  id: string,
): AxiosPromise<TMailBoxDetails> => {
  return httpClient.get(`/email/emailDetails?emailId=${id}&type=${emailType}`);
};
